<div class="container">
  <div class="row my-5 py-5">
    <multisite-content-list-formats [contentItems]="surveysAsContent" [imageTransformations]="imageTransformations"
      (itemSelected)="gotoSurvey($event)">
    </multisite-content-list-formats>
    @if (loading) {
      <multisite-loader-globe-animation-detail width="100" height="100" class="my-3"></multisite-loader-globe-animation-detail>
    }
  </div>
</div>